// extracted by mini-css-extract-plugin
export default {"theadDark":"Table_theadDark__A4-KA","noData":"Table_noData__zHgAi","noDataDesc":"Table_noDataDesc__gy1Q3"};